import request from '@/utils/request'
//添加自测试题
export function testGen(data) {
	return request({
		url: '/selfTest/test/generateTest',
		method: 'post',
		data
	})
}

//查询个人的自测记录
export function testlist(data) {
	return request({
		url: 'selfTest/test/getSelfTestList',
		method: 'get',
		params: data
	})
}

//根据记录id查询答题的详细信息
export function taskInfo(data) {
	return request({
		url: '/selfTest/test/getSelfTestDetail',
		method: 'get',
		params: data
	})
}

//提交作答试题
export function testcommit(data) {
	return request({
		url: '/selfTest/test/commit',
		method: 'post',
		data
	})
}

